<template>
  <div>
    <ListView
      ref="listView"
      :isFluid="true"
      title="代理管理"
      @reload="reload"
      @create="actionCreate"
      :search.sync="search"
      :data="data"
      :page.sync="page"
      :header="header"
      :enableCreate="false"
      search-box-placeholder="搜尋代理名稱 / 電話"
      @navDetails="actionDetails"
    >
      <!-- Custom Search Box -->
      <template v-slot:searchBox>
        <v-row dense>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="searchField"
              :items="searchFieldOptions"
              dense
              outlined
              hide-details
              label="搜尋欄位"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="searchVal"
              dense
              outlined
              hide-details
              :placeholder="searchFieldLabel"
              prepend-inner-icon="mdi-magnify"
              clearable
            />
          </v-col>
        </v-row>
      </template>

      <!-- Format createdAt -->
      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | moment('YYYY-MM-DD HH:mm') }}
      </template>

      <!-- Actions -->
      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="primary" @click.stop="actionDetails(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </ListView>

    <AgentDetailsDialog
      v-model="editDialog"
      :id="editId"
      @saved="handleSaved"
      @deleted="handleDeleted"
    />
  </div>
</template>

<script>
import { RESTFUL } from '@/data/constants';
import listViewPageMixin from '@/services/listViewPageMixin';
import AgentDetailsDialog from '@/components/Agent/AgentDetailsDialog';
import api from '@/api';

export default {
  name: 'Agent',
  components: {
    AgentDetailsDialog,
  },
  data() {
    return {
      limit: 100,
      header: [
        { text: '代理名稱', value: 'name' },
        { text: '電話', value: 'phone' },
        { text: '創建日期', value: 'createdAt' },
        // {
        //   text: '操作',
        //   value: 'actions',
        //   sortable: false,
        // },
      ],
      populate: '',
      editDialog: false,
      editId: 'new',
      searchField: 'name',
      searchFieldOptions: [
        { text: '代理名稱', value: 'name' },
        { text: '電話', value: 'phone' },
      ],
      sort: { createdAt: -1 },
    };
  },
  mixins: [listViewPageMixin],
  computed: {
    restfulURL() {
      return RESTFUL.agent.list;
    },
    searchFieldLabel() {
      const field = this.searchFieldOptions.find(f => f.value === this.searchField);
      return field ? `請輸入${field.text}` : '請輸入搜尋內容';
    },
    searchVal: {
      get() {
        return this.search;
      },
      set(val) {
        this.search = val;
      },
    },
    searchPaths() {
      return this.searchField ? [this.searchField] : undefined;
    },
    filter() {
      // Filter to only show agents (type: 'agent')
      return {
        type: 'agent',
      };
    },
  },
  methods: {
    actionCreate() {
      this.editId = 'new';
      this.editDialog = true;
    },
    actionDetails(item) {
      this.editId = item._id;
      this.editDialog = true;
    },
    handleSaved() {
      this.reload();
    },
    handleDeleted() {
      this.reload();
    },
  },
};
</script>
